import ConstructorIOClient from '@constructor-io/constructorio-client-javascript';

const cioClient = new ConstructorIOClient({
  apiKey: 'key_x6UnCVRZaJgIHFQD', // Tiku's Threads
});

export default cioClient;
